import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { lionSelectors } from '@rosetta/react-lion/dist/index';
import { mediumGrey, white } from '../../../styles/colors';
import { isMobile as isMobileDetected } from 'react-device-detect';

const LogoutSsoDiv = styled.div(() => {
  let style = {
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: white
  };
  return style;
});

const LogoutSsoBox = styled.div(() => {
  let style = {
    color: mediumGrey,
    textAlign: 'center',
    width: '400px'
  };
  return style;
});
const LogoutHeader = styled.div(() => {
  let style = {
    fontSize: '32px',
    lineHeight: '35px',
    marginBottom: '30px'
  };
  return style;
});

const LogoutText = styled.div(() => {
  let style = {
    fontSize: '16px',
    lineHeight: '25px'
  };
  return style;
});

const LogoutTextPublic = styled.div((props) => {
  let style = {
    fontSize: '16px',
    lineHeight: '25px',
    display: props.isMobile ? 'none' : 'block',
    paddingTop: '25px'
  };
  return style;
});

//*********************************************
export class LogoutSso extends PureComponent {
  componentWillMount = () => {};

  render = () => {
    if (!this.props.lionLoaded) {
      return null;
    }
    const isMobile = isMobileDetected;

    return (
      <LogoutSsoDiv data-qa="LogoutSso">
        <LogoutSsoBox>
          <LogoutHeader dangerouslySetInnerHTML={{__html:this.props.lionTranslateString('logoutsso_header')}} />
          <LogoutText>{this.props.lionTranslateString('logoutsso_subheader')}</LogoutText>
          <LogoutTextPublic isMobile={isMobile}>
            {this.props.lionTranslateString('logoutsso_subheader_shared')}
          </LogoutTextPublic>
        </LogoutSsoBox>
      </LogoutSsoDiv>
    );
  };
}

LogoutSso.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  }
});

const wrapActions = {};
export const LogoutSsoContainer = connect(
  mapStateToProps,
  wrapActions
)(LogoutSso);



// WEBPACK FOOTER //
// ./src/modules/login/components/LogoutSso.jsx